// src/data/testimonials.js
export const testimonials = [
    {
      id: '1',
      name: 'María González',
      role: 'Chef Profesional',
      image: '/images/testimonials/chef.jpg',
      comment: 'La mejor salsa de soya que he probado. Uso el formato de 5L en mi restaurante y mis clientes siempre destacan el sabor auténtico de los platos.',
      rating: 5
    },
    {
      id: '2',
      name: 'Carlos Muñoz',
      role: 'Amante de la Cocina',
      image: '/images/testimonials/home-cook.jpg',
      comment: 'La salsa teriyaki es excepcional, le da un toque especial a mis platos. La calidad es constante y el servicio al cliente es excelente.',
      rating: 5
    },
    {
      id: '3',
      name: 'Ana Silva',
      role: 'Food Blogger',
      image: '/images/testimonials/blogger.jpg',
      comment: 'Productos de excelente calidad. Los he usado en múltiples recetas para mi blog y siempre obtengo resultados perfectos.',
      rating: 5
    }
  ];